import { BaseEntity } from '@undp/carbon-library';

export class ProgrammeCertify implements BaseEntity {
  programmeId?: string;

  comment?: string;
}
